// Leaflet-freie ED-269-Gültigkeits-/Ablauf-Logik. Eigenes Modul, damit der
// tsx-Test-Runner (bash web/run-tests.sh) diese reinen Funktionen importieren
// kann, ohne ed269Web.ts (zieht leaflet -> `window`) zu laden. ed269Web.ts
// re-exportiert von hier, sodass es keine zweite Quelle gibt.
import { isGeozoneExpired } from "../../../shared/geozoneAltitudeFilter";

// Liefert das Gültigkeitsende (ms) eines ED-269-Features aus den Roh-Properties.
// Spiegelt die native ed269ValidityFromProps-Logik: Belgien (skeyes) liefert
// validEndTs direkt als ms; AT/generisch über applicability[] (endDateTime, das
// späteste Ende). Dauerhafte Zonen (permanent / kein Ende) -> null.
export function ed269WebValidEndTs(p: Record<string, any>): number | null {
  const de = Number(p?.validEndTs);
  if (Number.isFinite(de)) return de;
  if (Number.isFinite(Number(p?.validStartTs))) return null;
  if (p?.permanent === true || String(p?.permanent ?? "").toUpperCase() === "YES") return null;
  const app = p?.applicability;
  if (Array.isArray(app) && app.length > 0) {
    if (app.some((a: any) => String(a?.permanent ?? "").toUpperCase() === "YES")) return null;
    let max: number | null = null;
    for (const a of app) {
      if (a?.endDateTime) {
        const e = new Date(a.endDateTime).getTime();
        if (!isNaN(e) && (max === null || e > max)) max = e;
      }
    }
    return max;
  }
  return null;
}

// Blendet abgelaufene ED-269-Features (Gültigkeitsende in der Vergangenheit)
// aus. Dauerhafte/noch gültige Zonen bleiben erhalten. Spiegelt die native
// Filterung in parseEd269ToGeozoneInfo für die Web-Karte.
export function filterExpiredEd269Features(features: GeoJSON.Feature[]): GeoJSON.Feature[] {
  const now = Date.now();
  return (features || []).filter(
    (f) => !isGeozoneExpired(ed269WebValidEndTs((f?.properties || {}) as Record<string, any>), now),
  );
}
